<template>
  <div>
    <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
    </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
      <div ref="testHtml">
        <div v-for="page in totalPages" :key="page" class="mx-5 my-4">
          <div class="pdf-item d-flex text-xs justify-content-between">
            <div>
              <img
                src="../assets/gunter_Logo-bg.png"
                alt="Logo"
                style="flex: none;"
                height="30"
                width="30"
              />
              <h4
              class="smalltext"
              >
                GUNTER SHIPPING
                <br/>
                1100 LINWOOD
                <br/>
                BROOKLYN, NEW YORK 11208
                <br>
                Tel : 718-671-2000
              </h4>
            </div>
            <div>
              <!-- <img
                src="../assets/QR.png"
                alt="Logo"
                style="flex: none;"
                height="100"
                width="100"
              /> -->
              <VueQRCodeComponent v-if="token"  :text="`https://gunter.soonforward.us/#/shipmentStatus?token=${token}`" error-level="L" :size="150"></VueQRCodeComponent>
              <span v-if="token">Scan to Track </span>
            </div>
          </div>
                    <div  class="text-xs pdf-item ">
            <div>
              Booked Date: {{ dateCreated != null ? dateCreated : currentDateTime()  }}
            </div>
            <div>
              Estimated PickUp Date:
              {{ response.pickupDetails.pickupStartTime == null ?
              '' :
              new Date(
                `${response.pickupDetails.pickupStartTime} ${pickupStartTime}`
                ).toLocaleString(
                'en-US',{ dateStyle: 'short', timeStyle: 'short'}
                ) }}
            </div>
          </div>
          <div class="pdf-item mb-2 d-flex text-xl justify-content-center font-weight-bold">
            <div>
                CUSTOMER BILL OF LADING
            </div>
          </div>
          <div class="pdf-item mb-2">
            <table class="table table-bordered text-xs w-100" style="line-height: 1;">
              <tr>
                <th>SHIPPER</th>
                <th>CONSIGNEE</th>
              </tr>
              <tr>
                <td>
                  {{ response.shipper.firstName.toUpperCase() }}
                  {{ response.shipper.lastName.toUpperCase() }}
                  <br/>
                  {{ response.shipper.address.toUpperCase() }}
                  <br/>
                  {{ response.shipper.city.toUpperCase() }},
                  {{ response.shipper.state.toUpperCase() }}
                  {{ response.shipper.zipCode }}
                  <br/>
                  {{ response.shipper.country.toUpperCase() }}
                  <br/>
                  Tel: {{ response.shipper.phone }}
                </td>
                <td>
                  {{ response.consignee.firstName.toUpperCase() }}
                  {{ response.consignee.lastName.toUpperCase() }}
                  <br/>
                  {{ response.consignee.address.toUpperCase() }}
                  <br/>
                  {{ response.consignee.city.toUpperCase() }},
                  {{ response.consignee.state.toUpperCase() }}
                  {{ response.consignee.zipCode }}
                  <br/>
                  {{ response.consignee.country.toUpperCase() }}
                  <br/>
                  Tel: {{ response.consignee.phone }}
                </td>
              </tr>
            </table>
          </div>

          <div class="pdf-item mb-2 text-center">
            <table class="table table-bordered text-xs w-100" style="line-height: 0;">
                <tr>
                  <th>BL NUMBER</th>
                  <th>PIECES</th>
                  <th>GROSS WEIGHT</th>
                  <th>CHARG WEIGHT</th>
                  <th>VOLUMEN</th>
                </tr>
                <tr>
                  <th>{{ response.id }}</th>
                  <th>{{ totalPackage }}</th>
                  <th>{{ totalWeight }}</th>
                  <th>{{ totalWeight }}</th>
                  <th>{{ totalVolume }}</th>
                </tr>
            </table>
          </div>

          <div class="pdf-item mb-2">
            <table class="bordered  text-xs w-100" style="line-height: 1;">
                <tr class ="heading text-center">
                  <th>DETAILS</th>
                  <th class="borderedLeft" >CHARGES</th>
                </tr>
                <tr v-for="(item, index) in paginatedData(page-1)"
                  :key="item.id">
                  <td v-if="item.packageType">
                    {{ item.qty }}
                    {{ item.packageType.toUpperCase() }}
                    ({{ item.description }})
                    {{ item.length }} x {{ item.width }} x {{ item.height }}
                    <br>
                    SEAL:
                    <span v-for="(seal, index) in item.seal" :key="index">
                        <span v-if="seal.value">
                          <span v-if="index !== item.seal.length & index != 0">/</span>
                          {{ seal.value }}
                        </span>
                    </span>
                  </td>
                  <td v-else>
                    <br>
                    <br>
                  </td>
                  <td  class="borderedLeft" v-if="index == 0">
                    <div v-for="item in response.chargeDetails.charges"
                    :key="item.id" >
                      <div v-if="item.amount > 0">
                        {{ travelMode(response.itemDetails.travelMode).toUpperCase() }}
                        {{ item.name.toUpperCase() }} ${{ item.amount }}
                      </div>
                    </div>
                  </td>
                  <td class="borderedLeft" v-else>
                  </td>
                </tr>
            </table>
          </div>

          <!-- <div class="pdf-item mb-2">
            <table class="table table-bordered text-xs w-100" style="line-height: 1;">
                <tr class ="text-center">
                  <th>DETAILS</th>
                  <th>CHARGES</th>
                </tr>
                <tr v-for="(item, index) in paginatedData(page-1)"
                  :key="item.id">
                  <td style="border-bottom-style: hidden;
                border-top-style: hidden;" v-if="item.packageType">
                    {{ item.count }}
                    {{ item.packageType.toUpperCase() }}
                    ({{ item.description }})
                    {{ item.length }} x {{ item.width }} x {{ item.height }}
                    <br>
                     SEAL: {{ item.seal }}
                  </td>
                  <td style="border-top-style: hidden;
                  border-bottom-style: hidden;" v-else>
                    <br>
                    <br>
                  </td>
                  <td style="border-top-style: hidden;
                  border-bottom-style: hidden;
                      " v-if="index == 0">
                    <div v-for="item in response.chargeDetails.charges"
                    :key="item.id" >
                      <div v-if="item.amount > 0">
                        {{ travelMode(response.itemDetails.travelMode).toUpperCase() }}
                        {{ item.name.toUpperCase() }} ${{ item.amount }}
                      </div>
                    </div>
                  </td>
                  <td style="border-top-style: hidden;
                  border-bottom-style: hidden;" v-else>
                  </td>
                </tr>
                <tr>
                  <td style="border-top-style: hidden;">
                    <div class="d-flex justify-content-between">
                    <div>Agent:</div>
                    <div>
                      {{ response.agent.firstName.toUpperCase() }}
                      {{ response.agent.lastName.toUpperCase() }}
                      <br/>
                      {{ response.agent.address.toUpperCase() }}
                      <br/>
                      Tel: {{ response.agent.phone }}
                    </div>
                  </div>
                  </td>
                  <td class="font-weight-bold text-xl">
                  <div class="d-flex justify-content-between">
                  <div>TOTAL...</div>
                  <div>
                  $ {{ response.chargeDetails.charges.reduce((acc, curr) => acc + curr.amount, 0) }}
                  </div>
                  </div>
                  </td>
                </tr>
            </table>
          </div> -->

          <div class="pdf-item mb-2">
            <table class="table table-bordered text-xs w-100" style="line-height: 1;">
                <tr>
                  <th>AGENT</th>
                  <th>TOTAL</th>
                </tr>
                <tr>
                <td>
                  {{ response.agent.firstName.toUpperCase() }}
                  {{ response.agent.lastName.toUpperCase() }}
                  <br/>
                  {{ response.agent.address.toUpperCase() }}
                  <br/>
                  {{ response.agent.city.toUpperCase() }},
                  {{ response.agent.state.toUpperCase() }}
                  {{ response.agent.zipCode }}
                  <br/>
                  {{ response.agent.country.toUpperCase() }}
                  <br/>
                  Tel: {{ response.agent.phone }}
                </td>
                <td class="font-weight-bold text-xl text-center">
                  $ {{ response.chargeDetails.charges.reduce((acc, curr) => acc + curr.amount, 0) }}
                </td>
              </tr>
            </table>
          </div>
          <!-- <div class="pdf-item mb-2 text-xs">
            <div class="font-weight-bold">
              TERMS & CONDITIONS: All cargo tendered is subject to search and inspection as
              per TSA/Customs Rules.
            </div>
            <ul>
              <li>
              DANGEROUS, HAZARDOUS OR NOXIOUS CARGO MUST BE DECLARED AND ALL NECESSARY DOCUMENTS
              PERTAINING TO SHIPPING HAZARDOUS CARGO MUST BE PRESENTED AT TIME OF RECEIVING CARGO.
              Goods of a flammable, explosive, corrosive, radioactive, noxious, hazardous, unstable
              or  dangerous nature shipped without will description in writing to the carrier as
              to there and character, may at any time before discharge, be landed at any place,
              thrown overboard, destroyed or rendered innocuous without liability on the part
              of the carrier.
              </li>
              <li>
              PACKAGING: packaging guidelines have been issued by the carrier. The carrier shall
              not be responsible for any damages due to improper packaging. NOT PROPERLY PACKAGED...
              </li>
              <li>
              SHIPPER, WEIGHT, LOAD, AND COUNT: if cargo is not packaged by the carrier, then the
              carrier shall have no responsibility  or liability whatsoever for the packaging,
              loading, shoring, securing and/or storing of cargo or for loss or damage caused
              thereby or resulting their from.
              </li>
                <span class="font-weight-bold">
                  <i>FULL PAYMENT MUST MADE BEFORE SHIPMENT IS RELEASED AT DESTINATION</i>
                </span>
              <li>
              GUNTER SHIPPING is not responsible for anything broken or spoiled that been packed by
              customer.
              </li>
              <li>
              GUNTER SHIPPING is not responsible for delay of shipment due to ship not leaving or
              arriving on time or however occasioned.
              </li>
              <li>
              GUNTER SHIPPING is not responsible for customs duties and problems and at no time
                assumes responsibility for same, however, in cases where agents are, they will
                assist in clearing goods through customs.
              </li>
              <li>
              GUNTER SHIPPING is not responsible for goods left over 60 days in their warehouse
                or storage charges at port.
              </li>
              <li>
              Lost or damage must be reported in writing upon inspection at the Port or upon
              delivery of cargo by agent, to agent or representative. Reports made after
              would be denied. insurance is available (itemized packing list and value is required).
              Fill out and return within 3 days of pickup.
              </li>
              <li>
              GUNTER SHIPPING liability is limited to $150.00 in any one shipment.
              </li>
              <li>
              I agree to the terms and conditions of this contract
              </li>
              <li>
              I also declare that the items I am shipping are hereby noted as being
              <span v-if = hazardous>__<u class="font-weight-bold">X</u></span>__HAZARDOUS
              <span v-if = !hazardous>__<u class="font-weight-bold">X</u></span>__NON HAZARDOUS
              </li>
            </ul>
            <div class="mb-2">
              <div>
                Customer Signature
                <span class="mr-4">____________________________________</span>
                Date
                <span>____________________</span>
              </div>
              <div class="font-weight-bold">
                EXAMINED
                <span class="mr-4">______YES</span>
                <span class="mr-4">______NO</span>
                Receiving Clerk
                <span>____________________________________</span>
                <br>
                Date
                <span>____________________</span>
                Time
                <span>____________________</span>
              </div>
            </div>
          </div> -->
          <div v-if="page < totalPages" class="html2pdf__page-break" />
        </div>
        <div class="html2pdf__page-break" />
        <div class="mx-5 my-4">
          <div class="pdf-item d-flex text-xs justify-content-center">
          <div>
            <div class="font-weight-bold">
              TERMS & CONDITIONS: All cargo tendered is subject to search and inspection as
              per TSA/Customs Rules.
            </div>
            <ul>
              <li>
              DANGEROUS, HAZARDOUS OR NOXIOUS CARGO MUST BE DECLARED AND ALL NECESSARY DOCUMENTS
              PERTAINING TO SHIPPING HAZARDOUS CARGO MUST BE PRESENTED AT TIME OF RECEIVING CARGO.
              Goods of a flammable, explosive, corrosive, radioactive, noxious, hazardous, unstable
              or  dangerous nature shipped without will description in writing to the carrier as
              to there and character, may at any time before discharge, be landed at any place,
              thrown overboard, destroyed or rendered innocuous without liability on the part
              of the carrier.
              </li>
              <li>
              PACKAGING: packaging guidelines have been issued by the carrier. The carrier shall
              not be responsible for any damages due to improper packaging. NOT PROPERLY PACKAGED...
              </li>
              <li>
              SHIPPER, WEIGHT, LOAD, AND COUNT: if cargo is not packaged by the carrier, then the
              carrier shall have no responsibility  or liability whatsoever for the packaging,
              loading, shoring, securing and/or storing of cargo or for loss or damage caused
              thereby or resulting their from.
              </li>
                <span class="font-weight-bold">
                  <i>FULL PAYMENT MUST MADE BEFORE SHIPMENT IS RELEASED AT DESTINATION</i>
                </span>
              <li>
              GUNTER SHIPPING is not responsible for anything broken or spoiled that been packed by
              customer.
              </li>
              <li>
              GUNTER SHIPPING is not responsible for delay of shipment due to ship not leaving or
              arriving on time or however occasioned.
              </li>
              <li>
              GUNTER SHIPPING is not responsible for customs duties and problems and at no time
                assumes responsibility for same, however, in cases where agents are, they will
                assist in clearing goods through customs.
              </li>
              <li>
              GUNTER SHIPPING is not responsible for goods left over 60 days in their warehouse
                or storage charges at port.
              </li>
              <li>
              Lost or damage must be reported in writing upon inspection at the Port or upon
              delivery of cargo by agent, to agent or representative. Reports made after
              would be denied. insurance is available (itemized packing list and value is required).
              Fill out and return within 3 days of pickup.
              </li>
              <li>
              GUNTER SHIPPING liability is limited to $150.00 in any one shipment.
              </li>
              <li>
              I agree to the terms and conditions of this contract
              </li>
              <li>
              I also declare that the items I am shipping are hereby noted as being
              <span v-if = hazardous>__<u class="font-weight-bold">X</u></span>__HAZARDOUS
              <span v-if = !hazardous>__<u class="font-weight-bold">X</u></span>__NON HAZARDOUS
              </li>
            </ul>
            <div class="mb-2">
              <div>
                Customer Signature
                <span class="mr-4">____________________________________</span>
                Date
                <span>____________________</span>
              </div>
              <div class="font-weight-bold">
                EXAMINED
                <span class="mr-4">______YES</span>
                <span class="mr-4">______NO</span>
                Receiving Clerk
                <span>____________________________________</span>
                <br>
                Date
                <span>____________________</span>
                Time
                <span>____________________</span>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  name: 'BOLReceipt',
  props: [
    'name',
    'response',
    'currentUser',
    'token',
    'dateCreated',
    'pickupStartTime',
  ],
  data() {
    return {
      pdfFile: null,
      seen: {},
      size: 2,
      travelModes: [
        { value: null, text: '' },
        { value: 'oceanDirect', text: 'Ocean Direct' },
        { value: 'oceanTranshipment ', text: 'Ocean Transshipment' },
        { value: 'air', text: 'Air' },
        { value: 'ground', text: 'Ground' },
      ],
    };
  },
  computed: {
    hazardous() {
      return this.response.itemDetails.items.reduce((acc, item) => acc || item.hazardous, false);
    },
    totalWeight() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.weight * curr.qty, 0);
    },
    totalVolume() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.volume * curr.qty, 0);
    },
    totalPages() {
      return Math.ceil(this.response.itemDetails.items.length / this.size);
    },
    totalPackage() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.qty, 0);
    },
    // filteredArr() {
    //   this.reset();
    //   const filter = this.response.itemDetails.items.filter((el) => {
    //     if (el.packageType === '') {
    //       return false;
    //     }
    //     const duplicate = this.seen[el.packageType] !== undefined;
    //     if (duplicate) {
    //       this.seen[el.packageType] += 1;
    //     } else {
    //       this.seen[el.packageType] = 1;
    //     }
    //     return !duplicate;
    //   });
    //   return filter;
    // },
    // filteredArr() {
    //   const result = [];
    //   this.response.itemDetails.items.forEach((item) => {
    //     const resObj = result.find((obj) => obj.packageType === item.packageType
    //       && obj.length === item.length && obj.width === item.width
    //       && obj.height === item.height && obj.weight === item.weight);
    //     if (resObj) {
    //       resObj.count += 1;
    //     } else {
    //       result.push({ ...item, count: 1 });
    //     }
    //   });
    //   return result;
    // },
  },
  methods: {
    // test() {
    //   const data = { data: { id: this.response.id } };
    //   // console.log(this.response);
    //   this.token = '';
    //   tokenize(data).then((res) => {
    //     this.token = res.data.result;
    //   }).catch(() => {
    //   });
    //   return this.token;
    // },
    // lower(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toLowerCase().trim();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayLower(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.lower(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, {});
    //   return copy;
    // },
    // arrayLower(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toLowerCase().trim();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayLower(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.lower(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, []);
    //   return copy;
    // },
    travelMode(value) {
      const type = this.travelModes.find((mode) => mode.value === value);
      if (type) {
        return type.text;
      }
      return '';
    },
    paginatedData(page) {
      const start = page * this.size;
      const end = start + this.size;
      const paginated = this.response.itemDetails.items.slice(start, end);
      while (paginated.length < this.size) {
        paginated.push({
          packageType: '',
          description: '',
          weight: '',
          volume: '',
          length: '',
          height: '',
          width: '',
          seal: '',
          hazardous: false,
          flag: true,
          selectedWeightType: '',
          optionsWeightType: [
            { value: 'lbs', text: 'lbs' },
          ],
          selectedVolumeType: 'in3',
          optionsVolumeType: [
            { value: 'in3', text: 'in3' },
          ],
          selectedMeasureType: 'in',
          optionsMeasureType: [
            { value: 'in', text: 'in' },
          ],
        });
      }
      return paginated;
    },
    currentDateTime() {
      const today = new Date();
      return today.toLocaleDateString('en-US');
      // need to update
    },
    reset() {
      this.seen = {};
    },
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });
      const opt = {
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 600,
          scale: 4,
        },
      };

      html2pdf().from(this.$refs.testHtml).set(opt).output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
  components: {
    VueQRCodeComponent,
  },
};
</script>

<style lang="scss" scoped>
 body {
  font-family: Helvetica;
}
li:not(:last-child) {
    // margin-bottom: 5px;
    margin-bottom: 1px;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}

.heading {
  border-bottom: 1px solid #343434;
}

.bordered {
  border: 1px solid #343434;
}

.borderedLeft {
  border-left: 1px solid #343434
}

.smalltext {
  font-size: 0.55rem;
  line-height: .8rem;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }

}

</style>
